import React from 'react';

function LockedShieldIcon(props) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_3285_45263"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="36"
        height="36"
      >
        <path d="M36 0H0V36H36V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_3285_45263)">
        <mask
          id="mask1_3285_45263"
          maskUnits="userSpaceOnUse"
          x="18"
          y="-1"
          width="15"
          height="38"
        >
          <path
            d="M32.25 -0.459961H18.75C18.3358 -0.459961 18 -0.124175 18 0.290039V35.54C18 35.9543 18.3358 36.29 18.75 36.29H32.25C32.6642 36.29 33 35.9543 33 35.54V0.290039C33 -0.124175 32.6642 -0.459961 32.25 -0.459961Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_3285_45263)">
          <path
            d="M3.27539 7.56828C3.27539 6.97692 3.62285 6.44073 4.16264 6.19916L17.3878 0.280277C17.7777 0.105793 18.2235 0.105793 18.6133 0.280277L31.8385 6.19916C32.3783 6.44073 32.7258 6.97692 32.7258 7.56828V13.1865V23.1681C32.7258 25.1674 31.7299 27.0354 30.07 28.1497L18.8366 35.6909C18.331 36.0303 17.6702 36.0303 17.1646 35.6909L5.93116 28.1497C4.27123 27.0354 3.27539 25.1674 3.27539 23.1681V13.1865V7.56828Z"
            fill="#FF5200"
          />
        </g>
        <path
          d="M14.4258 14.8384C14.4258 12.8566 16.0221 11.25 17.9912 11.25C19.9603 11.25 21.5566 12.8566 21.5566 14.8384"
          stroke="black"
          strokeWidth="2"
        />
        <path
          d="M14.4375 15.5127H21.5625V22.4956H14.4375V15.5127Z"
          stroke="black"
          strokeWidth="2"
        />
        <path
          d="M6.64648 14.0031V9.10921L18.0014 4.02734L29.3564 9.10921V14.0031V23.0067C29.3564 23.9439 28.8896 24.8195 28.1115 25.3418L18.0014 32.1289L7.89139 25.3418C7.11328 24.8195 6.64648 23.9439 6.64648 23.0067V14.0031Z"
          stroke="black"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export default LockedShieldIcon;
